module.exports = __webpack_public_path__ + "img/help33.aff80d56.png";